import React, { useEffect } from "react";
import { Partner, getPartnerName } from "features/settings/importMapping/partner";
import ImportDetailsProps from "./importDetailsProps";
import { Form } from "react-bootstrap";
import NumberEditor from "common/ui/NumberEditor";

const partnersAllowingCustomerImport = new Set([Partner.Agris, Partner.Oakland, Partner.Agvance, Partner.EverAg]);
const ImportForCustomersDetails: React.FC<ImportDetailsProps> = props => {

    useEffect(() => {
        props.onIsValidChanged(isValid());
    }, [props.request]);


    function isValid(): boolean {
        if (props.request.recordIds.length === 0) return false;

        return true;
    }

    if (!partnersAllowingCustomerImport.has(props.partner)) {
        return <>Not supported for {getPartnerName(props.partner)}</>
    }

    return <>
        {[Partner.Agris, Partner.Agvance, Partner.EverAg].includes(props.partner) && <p>System will retrieve account and customer balance information for the given account IDs</p>}
        {props.partner === Partner.Oakland && <p>System will retrieve account, contract, and customer balance information for the given account IDs</p>}
        <div>
            <strong>Account IDs (one per line):</strong>
        </div>
        <div>
            <textarea className="form-control" rows={5} 
                value={props.request.recordIds.join('\n')}
                onChange={ev => props.onChange({...props.request, recordIds: ev.target.value.split('\n')})}>
            </textarea>
        </div>
        <div>
            <div>
                <Form.Check
                    name="forCustomerCreateRecord"
                    id="forCustomerCreateRecord"
                    label="Automatically create new customer for each account"
                    checked={props.request.createRecord}
                    onChange={ev => props.onChange({...props.request, createRecord: ev.target.checked})}
                />
            </div>
        </div>
        <div>
            <div className="form-inline">
                <Form.Label className="pr-2 optional">Batch size</Form.Label>
                <NumberEditor
                    min={1}
                    value={props.request.customArguments?.batchSize}
                    onValueChange={val => props.onChange({...props.request, customArguments: {...props.request.customArguments, batchSize: val}})}
                    />                
            </div>
        </div>
    </>;
}

export default ImportForCustomersDetails;